import { render, staticRenderFns } from "./SubColecoes.vue?vue&type=template&id=77548fc5&scoped=true&"
import script from "./SubColecoes.vue?vue&type=script&lang=js&"
export * from "./SubColecoes.vue?vue&type=script&lang=js&"
import style0 from "./SubColecoes.vue?vue&type=style&index=0&id=77548fc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77548fc5",
  null
  
)

export default component.exports